/**
 * Utility functions for audience match percentage color coding
 */

export function getMatchBadgeClasses(percentage: number): string {
  if (percentage >= 75) {
    return "bg-green-600 hover:bg-green-700 text-white";
  } else if (percentage >= 40) {
    return "bg-yellow-500 hover:bg-yellow-600 text-white";
  } else {
    return "bg-red-600 hover:bg-red-700 text-white";
  }
}

export function getMatchTextColor(percentage: number): string {
  if (percentage >= 75) {
    return "text-green-600";
  } else if (percentage >= 40) {
    return "text-yellow-600";
  } else {
    return "text-red-600";
  }
}

export function getMatchBgColor(percentage: number): string {
  if (percentage >= 75) {
    return "bg-green-100";
  } else if (percentage >= 40) {
    return "bg-yellow-100";
  } else {
    return "bg-red-100";
  }
}

export function getMatchBorderColor(percentage: number): string {
  if (percentage >= 75) {
    return "border-green-500";
  } else if (percentage >= 40) {
    return "border-yellow-500";
  } else {
    return "border-red-500";
  }
}

export function getMatchBadgeBackground(percentage: number): string {
  if (percentage >= 75) {
    return "bg-green-500/10";
  } else if (percentage >= 40) {
    return "bg-yellow-500/10";
  } else {
    return "bg-red-500/10";
  }
}

export function getMatchBadgeHoverBackground(percentage: number): string {
  if (percentage >= 75) {
    return "hover:bg-green-500/20";
  } else if (percentage >= 40) {
    return "hover:bg-yellow-500/20";
  } else {
    return "hover:bg-red-500/20";
  }
}